import {AppMenu} from "./AppMenu";
import {RicambiService} from '../service/ricambi.service';
export class AppSettings {

    public static traduzioni: any = new Object();
    public static lingua:string="";
    public static traduzioniNuove: any = new Object();


    //public static sezione: string = "ghibli";
    public static sezione: string = "wirbel";

    public static get FLAG_PATH():string{
        return this.API_ENDPOINT_BASE+"/"+AppSettings.sezione+"/img/flag/";
       // return this.API_ENDPOINT_BASE+"/img/flag/"
    }

    public static get API_ENDPOINT_BASE(): string {

        return 'https://app.nuvolaweb.cloud';
        //return 'http://localhost:8080/ghiblib2b';
        //return 'https://devnuvola.twsweb.it/';
        //return 'https://tws.nuvolaweb.cloud';
    }

    public static get API_ENDPOINT(): string {
        return this.API_ENDPOINT_BASE+"/"+AppSettings.sezione+'/api/data/';
       // return this.API_ENDPOINT_BASE+'/api/data/';
       
    }
    
   
    public static getArea(): string {
        if (AppSettings.sezione == "ghibli") {
            return "My G&W";
        } else {
            return "My Wirbel";
        }
    }

    public static get WS_ENDPOINT(): string {
        //return 'ws://app.nuvolaweb.cloud:8080/' + AppSettings.sezione + '/webservicePage/';
        //return 'ws://localhost:8100/ghiblib2b/webservicePage/';
        //return 'ws://172.22.2.100:8080/ghibli/webservicePage/';
        return 'wss://app.nuvolaweb.cloud:8443/'+AppSettings.sezione+'/webservicePage/';
    }
    public static get listaMenu(): Array<AppMenu> {
        let list: Array<AppMenu> = [
            new AppMenu("MY g&w", "/macchine", "assets/ricambi.png"),
           
            new AppMenu("Ricambi", "/ricambi", "assets/ricambi.png"),
            new AppMenu("Accessori", "/accessori", "assets/accessori.jpg"),
            new AppMenu("Documentazione", "/documentazione", "assets/documenti.png"),
            //new AppMenu("Domande", "/domande", "assets/domande.png"),
            //new AppMenu("Garanzia", "/richiestaGaranzia", ""),
            new AppMenu("Garanzie", "/matricole", ""),
             new AppMenu("Bacheca", "/bacheca", "assets/bacheca.png")
        ];
        return list;
    }

    public static aggiungiNuovaTraduzione(role: string) {
        AppSettings.traduzioni[role] = role;
        AppSettings.traduzioniNuove[role] = role;
    }

    public static traduci(role: string): string {
        return RicambiService.traduci(role);
    }

    public static get listaTraduzioni(): any {
        return AppSettings.traduzioni;
    }

    public static humanFileSize(bytes: number, si: boolean): string {
        var thresh = si ? 1000 : 1024;
        if (Math.abs(bytes) < thresh) {
            return bytes + ' B';
        }
        var units = si
            ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
            : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
        var u = -1;
        do {
            bytes /= thresh;
            ++u;
        } while (Math.abs(bytes) >= thresh && u < units.length - 1);
        return bytes.toFixed(1) + ' ' + units[u];
    }
    

}



// WEBPACK FOOTER //
// ./src/app/models/AppSettings.ts